import React from "react";
import { Link } from "react-router-dom";
import {
  StickerBolt, StickerSunflower, StickerStar, StickerSun, StickerHeart, StickerMoon,
} from "../components/Stickers";

const Shop = () => {
  return (
    <div>
      <section className="bg-[#B57FA0] border-b-4 border-black relative overflow-hidden">
        <div className="absolute top-8 left-8 hidden md:block"><StickerStar size={70} rotate={-15} className="float-slow" /></div>
        <div className="absolute bottom-8 right-8 hidden md:block"><StickerSunflower size={100} rotate={12} className="float-med" /></div>

        <div className="max-w-7xl mx-auto py-20 px-6 text-white">
          <div className="font-pixel uppercase tracking-widest text-lg text-white/80">▒▒ merch · new era ▒▒</div>
          <h1 className="font-display tracking-wider text-6xl sm:text-7xl lg:text-8xl mt-3">THE SHOP</h1>
          <p className="font-body text-xl mt-5 max-w-3xl text-white/90">
            A fresh start. Brand new merch is on the way, beginning with hoodies. Everything that came before
            is officially retired, which means if you've already got something, you've got a piece of
            CrossCanadaJax history.
          </p>
        </div>
      </section>

      {/* COMING SOON HERO */}
      <section className="py-24 px-6 relative overflow-hidden">
        <div className="absolute top-20 left-1/4 hidden md:block"><StickerSun size={80} rotate={-10} className="float-slow" /></div>
        <div className="absolute bottom-20 right-1/4 hidden md:block"><StickerHeart size={80} rotate={14} className="float-med" /></div>
        <div className="absolute top-1/3 right-[8%] hidden lg:block"><StickerMoon size={90} rotate={8} className="float-slow" /></div>

        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-block bg-[#F4D58D] border-4 border-black px-6 py-2 font-display text-3xl tracking-wider mb-8 shadow-[6px_6px_0_#000]">
            <span className="blink mr-2 text-[#F87171]">●</span> STATUS: BUILDING <span className="blink ml-2 text-[#F87171]">●</span>
          </div>

          <h2 className="font-display tracking-wider text-6xl sm:text-7xl text-black leading-none">
            HOODIES <span className="text-[#F87171]">COMING</span> FIRST
          </h2>
          <p className="font-body text-xl mt-6 text-black/80">
            The new CrossCanadaJax shop is being built right now. The first drop is hoodies, with more
            pieces rolling out from there. No books for now. Another one will happen, just not in the near future.
          </p>

          <div className="mt-10 inline-flex flex-col sm:flex-row gap-4">
            <button
              type="button"
              disabled
              data-testid="shop-coming-soon-cta"
              className="font-display text-2xl tracking-wider px-7 py-3 bg-black text-white border-4 border-black opacity-70 cursor-not-allowed"
            >
              Hoodies drop here →
            </button>
            <Link to="/speaking" data-testid="shop-alt-cta"
              className="font-display text-2xl tracking-wider px-7 py-3 bg-[#F87171] text-white border-4 border-black shadow-[6px_6px_0_#000] btn-press">
              Until then, book me to speak
            </Link>
          </div>
        </div>
      </section>

      {/* WHAT'S DROPPING */}
      <section className="bg-[#FFF4D6] border-y-4 border-black py-16 px-6 relative overflow-hidden">
        <div className="absolute top-6 right-6 hidden md:block"><StickerBolt size={70} rotate={14} className="float-med" /></div>

        <div className="max-w-5xl mx-auto">
          <h3 className="font-display tracking-wider text-4xl sm:text-5xl text-black leading-none"
              style={{ textShadow: "4px 4px 0 rgba(0,0,0,0.18)" }}>
            WHAT'S DROPPING
          </h3>
          <div className="hazard h-3 mt-3 mb-10" />

          <div className="grid sm:grid-cols-3 gap-6">
            <div className="bg-white border-4 border-black p-6 shadow-[8px_8px_0_#000]">
              <div className="font-pixel uppercase tracking-widest text-sm text-black/60">first drop</div>
              <div className="font-display text-3xl tracking-wider mt-1">Hoodies</div>
              <p className="font-body text-base mt-3 text-black/80">
                Retro graphics, designed for the road and the couch. The flagship piece of the new shop.
              </p>
            </div>
            <div className="bg-white border-4 border-black p-6 shadow-[8px_8px_0_#000]">
              <div className="font-pixel uppercase tracking-widest text-sm text-black/60">rolling out next</div>
              <div className="font-display text-3xl tracking-wider mt-1">More Apparel</div>
              <p className="font-body text-base mt-3 text-black/80">
                Tees, hats, and seasonal pieces will follow once the hoodies are out the door. One small drop at a time.
              </p>
            </div>
            <div className="bg-white border-4 border-black p-6 shadow-[8px_8px_0_#000]">
              <div className="font-pixel uppercase tracking-widest text-sm text-black/60">someday</div>
              <div className="font-display text-3xl tracking-wider mt-1">Book #2</div>
              <p className="font-body text-base mt-3 text-black/80">
                A second book is on the horizon. Not in the near future, but it's coming. The first book is permanently retired.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* RETIRED / LIMITED EDITION */}
      <section className="py-16 px-6 relative overflow-hidden">
        <div className="absolute top-10 left-10 hidden md:block"><StickerStar size={70} rotate={-12} className="float-slow" /></div>
        <div className="absolute bottom-10 right-10 hidden md:block"><StickerHeart size={70} rotate={12} className="float-med" /></div>

        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-block bg-[#F4A261] text-white border-4 border-black px-4 py-1 font-display tracking-wider text-2xl shadow-[4px_4px_0_#000] mb-4">
            ★ ARCHIVE ★
          </div>
          <h3 className="font-display tracking-wider text-4xl sm:text-5xl text-black leading-none"
              style={{ textShadow: "4px 4px 0 rgba(0,0,0,0.18)" }}>
            PREVIOUSLY SOLD ITEMS ARE NOW LIMITED EDITION
          </h3>
          <p className="font-body text-lg mt-6 text-black/80">
            The first book, the original hoodies, the early-run merch. All officially discontinued. If you picked
            something up during the cross-Canada run or the book tour, that piece is now permanently retired,
            and there won't be another one. Keep it safe. Wear it loud.
          </p>
          <p className="font-pixel text-lg text-black/60 mt-8">
            ☞ want to be notified when the new shop goes live?{" "}
            <a href="mailto:CrossCanadaJax97@gmail.com?subject=Notify%20me%20when%20the%20shop%20opens" className="retro-link" data-testid="shop-notify-email">
              email me
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Shop;
